<template>
    <v-layout v-if="asset" column d-flex>
        <v-tabs v-model="selectedTab">
            <v-tab key="general">Algemeen</v-tab>
            <v-tab key="geoEvents">POI's gekoppeld op asset</v-tab>            
            <v-tab key="geoEventOnGroups">POI's gekoppeld op assetgroep</v-tab>                        
        </v-tabs> 
        <v-tabs-items v-model="selectedTab">
        <!-- GENERAL TAB ---------------------------->
            <v-tab-item key="general">    
                <v-layout v-if="asset" row d-flex wrap>
                    <v-flex sm12 lg8>
                        <v-layout column sm12>
                            <v-flex sm12 lg12 >
                                <v-divider></v-divider>
                                <v-flex px-3 pt-3>
                                    <v-text-field
                                        label="Unit identificatie nummer"
                                        v-model="unitIdentifier"                
                                        disabled
                                    ></v-text-field>
                                    <v-text-field
                                        label="Naam"
                                        v-model="name"                
                                    ></v-text-field>
                                    <v-select 
                                        label="Groep"   
                                        :items="assetGroups"      
                                        item-text="name"                               
                                        item-value="id"
                                        v-model="assetGroupId"
                                    ></v-select>
                                    <v-select 
                                        label="Type"
                                        :items="assetTypes"      
                                        item-text="name"                               
                                        item-value="id"
                                        v-model="assetTypeId"
                                    ></v-select>
                                </v-flex>                
                            </v-flex>
                            <v-flex sm12 lg12 mt-4 >
                                <v-subheader>Extra velden</v-subheader>
                                <v-divider></v-divider>
                                <v-flex px-3 pt-3 >
                                    <v-flex v-for="customField of assetGroupCustomFields" :key="customField.id" class="pt-1">                        
                                        <v-select
                                            v-if="customField.type.internalName == 'select'"
                                            :items="customField.allowedValues"
                                            item-value="value"
                                            item-text="value"
                                            :label="customField.name"
                                            v-model="selectedCustomFields[customField.name]"
                                            :disabled="customField.protected"
                                        ></v-select>
                                        <v-checkbox 
                                            v-if="customField.type.internalName == 'checkbox'"
                                            v-model="selectedCustomFields[customField.name]" 
                                            :value="customField.allowedValues[1].value"
                                            :label="customField.name"
                                            :disabled="customField.protected"                                            
                                        ></v-checkbox>
                                        <v-slider
                                            :label="customField.name"
                                            v-if="customField.type.internalName == 'numeric_range'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            :max="rangeMaximum(customField.allowedValues)"
                                            :min="rangeMinimum(customField.allowedValues)"
                                            thumb-label="always"             
                                            :disabled="customField.protected"                                                           
                                        ></v-slider>
                                        <v-text-field
                                            v-if="customField.type.internalName == 'numeric'"
                                            v-model="selectedCustomFields[customField.name]" 
                                            mask="############"
                                            :label="customField.name"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>
                                        <v-text-field
                                            v-if="customField.type.internalName == 'time'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            :label="customField.name"
                                            prepend-icon="far fa-clock"
                                            mask="time"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>
                                        <template v-if="customField.type.internalName == 'date'">                                            
                                            <v-menu
                                                v-model="showElementModel[customField.name]"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                            >
                                                <v-text-field
                                                    slot="activator"
                                                    v-model="selectedCustomFields[customField.name]"
                                                    :label="customField.name"
                                                    prepend-icon="event"
                                                    readonly
                                                    >
                                                </v-text-field>
                                                <v-date-picker v-model="selectedCustomFields[customField.name]" @input="showElementModel[customField.name] = false"></v-date-picker>                                                
                                            </v-menu>
                                        </template>                                                                                
                                        <v-text-field
                                            v-if="customField.type.internalName == 'text'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            :label="`${customField.name}`"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>  
                                        <v-text-field
                                            v-if="customField.type.internalName == 'celsius'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            prepend-icon="fal fa-temperature-high"
                                            :label="`${customField.name}  (${customField.type.name})`"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>                                                                                

                                        <v-text-field
                                            v-if="customField.type.internalName == 'mps'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            prepend-icon="fas fa-wind"
                                            :label="`${customField.name}  (${customField.type.name})`"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>          
                                        <v-text-field
                                            v-if="customField.type.internalName == 'degrees'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            prepend-icon="fas fa-compass"
                                            :label="`${customField.name}  (${customField.type.name})`"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>     
                                        <v-text-field
                                            v-if="customField.type.internalName == 'percentage'"
                                            v-model="selectedCustomFields[customField.name]"                             
                                            prepend-icon="far fa-percent"
                                            :label="`${customField.name}  (${customField.type.name})`"
                                            :disabled="customField.protected"                                            
                                        ></v-text-field>                                                                                         
                                    </v-flex>
                                    <!-- <v-text-field
                                        label="Naam"
                                        v-model="name"                
                                    ></v-text-field>
                                    <v-select 
                                        label="Type"   
                                        :items="assetGroups"      
                                        item-text="name"                               
                                        item-value="id"
                                        v-model="assetGroupId"
                                    ></v-select>
                                    <v-select 
                                        label="Groep"
                                        :items="assetTypes"      
                                        item-text="name"                               
                                        item-value="id"
                                        v-model="assetTypeId"
                                    ></v-select> -->
                                </v-flex>                
                            </v-flex>    
                        </v-layout>
                    </v-flex>   
                    <v-flex sm12 lg10>
                        <v-layout column >
                            <v-flex sm12 lg12 grey lighten-4 d-flex class="file-upload-holder px-2 ml-3 py-3" >                            
                                
                                    
                                <v-flex v-if="!asset.mainImage">
                                    <strong>Afbeelding</strong><br><br>

                                    <file-upload 
                                        class="px-2"
                                        :url="imageUploadUrl" 
                                        @isUploading="imageUploading"
                                        @uploadDone="imageUploadingDone"
                                        :blockUI="true"
                                    ></file-upload>
                                </v-flex>
                                <v-flex v-else d-flex class="px-2 py-3">
                                        <v-flex d-flex>
                                            <img :src="imageUrl" class="dd-uploaded-image" style='height: 100%; width: 100%; object-fit: contain'>
                                        </v-flex>
                                        
                                        <div class="btn-image-delete">
                                            <v-btn color="accent" fab @click="deleteMainImage()">                                
                                                <v-icon class="fas fa-trash"></v-icon>
                                            </v-btn>
                                        </div>                        
                                </v-flex>                    
                            </v-flex>                  
                        </v-layout>
                    </v-flex>            
                </v-layout>
                <v-flex  class="px-2 right-button-container">
                    <v-btn  @click="$emit('cancelled')" v-if="showCancelButton">annuleren</v-btn>
                    <v-btn color="success" @click="saveAsset">opslaan</v-btn>
                    
                </v-flex>                 
            </v-tab-item>    
        <!-- GEOEVENTS TAB ---------------------------->
            <v-tab-item key="geoEvents">                        
                <asset-geo-zone-events :asset="asset" :allowNew="allowNewGeoZoneEventOnAsset"></asset-geo-zone-events>                
            </v-tab-item>     
            <v-tab-item key="geoEventOnGroups">                        
                <asset-group-geo-zone-events  :assetGroup="asset.group" :unitType="asset.unitType"></asset-group-geo-zone-events>                
            </v-tab-item>                        
        </v-tabs-items>                                
    </v-layout>                    
</template>
<script>
import { API_URL, IMAGE_URL } from "../../config"
import { mapGetters } from "vuex";
import * as types from "../../store/types";
import FileUpload from '../form/FileUpload'
import AssetGeoZoneEvents from '../../components/asset/AssetGeoZoneEvents'
import AssetGroupGeoZoneEvents from '../../components/asset/AssetGroupGeoZoneEvents'
import _ from 'lodash';

export default {
    props: {
        asset:{},
        allowNewGeoZoneEvent:{},
        showCancelButton: {
            default: false
        }
    },
    components: { FileUpload, AssetGeoZoneEvents, AssetGroupGeoZoneEvents },
    data(){
        return {
            unitIdentifier:'',
            allowNewGeoZoneEventOnAsset:1,
            selectedTab:0,
            name: '',
            assetTypeId: null,
            assetGroupId : null,
            selectedCustomFields: {

            },
            showElementModel: {

            }
                      
        }
    },
    computed:{
        ...mapGetters({
            assetGroups: types.ASSET_GROUPS,
            assetGroupCustomFields: types.ASSET_GROUP_CUSTOM_FIELDS,
            assetTypes: types.ASSET_TYPES,
        }),
        imageUploadUrl(){
            return `${ API_URL}/assets/${this.asset.id}/main-image`
        },
        imageUrl(){
            return `${IMAGE_URL}/${this.asset.mainImage.publicLocation}`;
        }
    },
    methods:{
        saveAsset(){
            this.$store.dispatch(types.SAVE_ASSET, { data: {                
                id: this.asset.id,
                name: this.name,
                assetTypeId: this.assetTypeId,
                assetGroupId: this.assetGroupId
            } }).then(() => {
                let obj = _.pickBy(this.selectedCustomFields, (ele) => ele != undefined)
                this.$store.dispatch(types.SAVE_ASSET_CUSTOM_FIELDS, {data: { assetId: this.asset.id, fields: obj } })  
                this.$notify('Wijzigingen voor asset zijn opgeslagen', {type: 'success', icon: 'check'})         
                this.$emit('assetSaved')     
            })
        },
        rangeMaximum(values){
            let maxKey = _.max(Object.keys(values), v => values[v]);            
            return values[maxKey].value
        },
        rangeMinimum(values){
            let minKey = _.min(Object.keys(values), v => values[v]);
            
            return values[minKey].value
        },
        imageUploading(e){
            console.log("uploading...", e)
        },
        imageUploadingDone(res){
            this.asset.mainImage = res;
            console.log("uploading done!")
        },
        deleteMainImage(){
            this.$store.dispatch(types.ASSET_DELETE_IMAGE, {data: { assetId: this.asset.id, imageId: this.asset.mainImage.id }}).then(() => {
                this.asset.mainImage = null
                this.$notify('Afbeelding succesvol verwijderd', { icon: 'check', type: 'success'})
            })
        }
        
    },
    mounted(){

        if(this.allowNewGeoZoneEvent){
            this.allowNewGeoZoneEventOnAsset = this.allowNewGeoZoneEvent
        }
        this.name = this.asset.name
        this.unitIdentifier = this.asset.unitIdentifier
        this.assetGroupId = this.asset.group.id
        this.assetTypeId = this.asset.type.id
        this.$store.dispatch(types.ASSET_GROUPS, {params:{per_page:200}})
        this.$store.dispatch(types.ASSET_GROUP_CUSTOM_FIELDS, {data: {id: this.asset.group.id}, params: {include: 'type'}}).then(() =>{
            this.$nextTick(() => {            

                for(let f of this.assetGroupCustomFields){
                    
                    let needle = null

                    // if customFields is not set or given 
                    if(this.asset.customFields)
                        needle = this.asset.customFields.find((ele) => { return ele.name == f.name }) 

                    let value = (needle) ? needle.value : null

                    if(needle){
                        this.$set(this.selectedCustomFields, f.name,  value);
                        //this.selectedCustomFields[f.name] = value
                    }
                    else{
                        this.selectedCustomFields[f.name] = null
                    }                
                }
            })
        })
        this.$store.dispatch(types.ASSET_TYPES, {})
        this.$store.dispatch(types.BACKGROUND_ICON, "edit");

        
    }
}
</script>
<style >
   /* .dd-uploaded-image{
        max-width:100%;
        height: auto !important;
   } */

   .btn-image-delete{
       flex:0;
       position: absolute;
       display: flex;
       justify-content: center;
       margin-left: -20px;
       margin-top: -20px;
   }
</style>